import React from 'react';
import EntityUpdater from '../EntityUpdater.js';
const Legal = (props) => {
    const { heading, collector } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null, heading),
        React.createElement(EntityUpdater, { key: "privacyPolicy", entity: "privacyPolicy", collector: collector }),
        React.createElement(EntityUpdater, { key: "businessTerms", entity: "businessTerms", collector: collector })));
};
export default Legal;
//# sourceMappingURL=Legal.js.map